import { useState, useEffect } from 'react';

export const useTipPopup = () => {
  const [hasUsedAI, setHasUsedAI] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [hasShownPopup, setHasShownPopup] = useState(false);

  useEffect(() => {
    const handleMouseLeave = (e) => {
      if (
        e.clientY <= 0 && // User moved mouse to top of viewport
        hasUsedAI && // User has used AI features
        !hasShownPopup && // Popup hasn't been shown yet
        !showPopup // Popup isn't currently showing
      ) {
        setShowPopup(true);
        setHasShownPopup(true);
      }
    };

    document.addEventListener('mouseleave', handleMouseLeave);
    return () => document.removeEventListener('mouseleave', handleMouseLeave);
  }, [hasUsedAI, hasShownPopup, showPopup]);

  const markAIUsed = () => setHasUsedAI(true);
  const closePopup = () => setShowPopup(false);

  return {
    showPopup,
    closePopup,
    markAIUsed
  };
}; 